import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {Map, List} from 'immutable';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import classnames from 'classnames';
import fillWithPlaceholders from 'utils/components/fillWithPlaceholders';
import {default as Tooltip} from 'components/Tooltip';
import {default as Facets, FacetItem} from 'components/Facets';
import {default as Spinner, SIZE_LARGE} from 'components/Spinner';
import StylesheetLink from 'components/StylesheetLink';
import {Request, GET, DELETE} from 'requests';
import {default as RequestsMixin, IS_QUEUED, IS_DONE} from 'requests/RequestsMixin';
import {ResourcesMatching, Requesting, Done} from 'requests/components';
import {default as JobMixin, PROCESSING, FINISHED} from '../mixins/JobMixin';
import ImageCard from './ImageCard';
import ImageCardPlaceholder from './ImageCardPlaceholder';

const NUMBER_OF_IMAGES_NEEDED = 16;
const IMAGE_MULTIPLES = 4;

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.params.kitToken;

  return {
    kitToken,
    requests: state.requests,
    jobs: state.jobs,
  };
};

const ImagesController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    requests: PropTypes.object.isRequired,
    kitToken: PropTypes.string.isRequired,
  },

  mixins: [RequestsMixin, JobMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      deleting: List(),
      refreshing: List(),
      showConfirmDeleteImage: null,
      showUsageBetaTooltip: false,
    };
  },

  componentWillMount() {
    this.setRequest({
      workingSetImages: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'working-set-images'],
      }),
    });

    this.setRequest({
      subscription: new Request({
        method: GET,
        url: ['api', 'subscriptions'],
      }),
    });
  },

  transitions(register) {
    register({
      request: this.requests.refreshWorkingSetImage,
      to: IS_DONE,
      call(rm) {
        const workingSetImage = rm.type(this.requests.refreshWorkingSetImage, 'working-set-images').get();

        this.setState({
          refreshing: this.state.refreshing.filterNot((n) => {
            return n.id === workingSetImage.id;
          }),
        });
      },
    });
  },

  isDeleting(workingSetImage) {
    const deletingIds = this.state.deleting.map((n) => n.id);

    return deletingIds.includes(workingSetImage.id);
  },

  handleDeleteImage(workingSetImage) {
    this.setState({
      deleting: this.state.deleting.push(workingSetImage),
    });

    this.setRequest({
      deletingWorkingSetImage: new Request({
        method: DELETE,
        url: ['api', 'kits', this.props.kitToken, 'working-set-images', workingSetImage.id],
        record: workingSetImage,
      }),
    });
  },

  toggleShowUsageBetaTooltip() {
    this.setState({showUsageBetaTooltip: !this.state.showUsageBetaTooltip});
  },

  resources() {
    const rm = this.resourceManager();

    return {
      workingSetImages: rm.type(this.requests.workingSetImages, 'working-set-images').all(),
      subscription: rm.type(this.requests.subscription, 'subscriptions').get(),
    };
  },

  renderHeaderIntro(withCluestick) {
    const alertClassname = classnames(
      'well m-xs-b-lg text-xs-center',
      {'br-t-0 bg-info-dark': withCluestick},
      {'bg-info': !withCluestick}
    );

    const labelClassname = classnames(
      'label font-weight-semibold text-white inline-block valign-middle m-xs-r-md p-xs-a-sm',
      {'bg-info': withCluestick},
      {'bg-info-light': !withCluestick}
    );

    const cluestick = (
      <div className="layout-center-center well bg-info bg-img bg-img-icons p-xs-a-xl m-xs-b-0 text-xs-center br-b-0" role="alert">

        <div className="text-muted m-xs-b-md">
          <i className="ficon ficon-5x ficon-curate"></i>
        </div>

        <h2 className="text-2x m-xs-b-md font-weight-semibold">Let us frame your images for the web!</h2>

        <p className="lead text-muted m-xs-b-0">
          Upload an image and we’ll automatically make it smaller. No visible quality loss, no resizing. It’s awesome.<br/>
        </p>
      </div>
    );

    return (
      <div>
        {(withCluestick) ? cluestick : null}
        <div className={alertClassname}>

          <span className={labelClassname}><span className="sr-only">This feature is in </span><span className="text-upper text-tracking">Beta</span></span>
          <p className="m-xs-b-0 inline-block valign-middle text-muted">
            We’re still polishing up this feature. If you have any trouble, feedback, or notice anything, <a href="mailto:help@fortawesome.com" className="text-white">let us know</a>.
          </p>
        </div>
      </div>
    );
  },

  renderUsage() {
    const {
      workingSetImages,
    } = this.resources();
    const {showUsageBetaTooltip} = this.state;

    const imagesUsed = workingSetImages.size;
    const usageBetaTooltip = (this.state.showUsageBetaTooltip) ?
      <Tooltip noIcon={true} content={"Use as many images as you'd like<br /> while this feature is in beta"} /> :
      null;

    return (
      <div onMouseEnter={this.toggleShowUsageBetaTooltip} onMouseLeave={this.toggleShowUsageBetaTooltip} className="text-muted m-xs-b-md">
        <span className="has-tooltip">
          {usageBetaTooltip}
          Using {imagesUsed} of &infin; available
        </span>
      </div>
    );
  },

  renderMain() {
    const {kitToken} = this.props;
    const {workingSetImages} = this.resources();

    const workingSetImagesElements = workingSetImages
      .sort((a, b) => {
        let val = 0;
        const aJobState = this.jobState(a);
        const bJobState = this.jobState(b);

        if (a.createdAt.isAfter(b.createdAt)) {
          val = -1;
        } else if (b.createdAt.isAfter(a.createdAt)) {
          val = 1;
        }

        if (aJobState === FINISHED && bJobState === PROCESSING) {
          val = 1;
        } else if (bJobState === FINISHED && aJobState === PROCESSING) {
          val = -1;
        }

        return val;
      })
      .map((workingSetImage) => {
        const jobState = this.jobState(workingSetImage);

        return (
          <ImageCard
            key={workingSetImage.id}
            kitToken={kitToken}
            workingSetImage={workingSetImage}
            jobState={jobState}
            isDeleting={this.isDeleting(workingSetImage)}
            onDeleteImage={this.handleDeleteImage}
          />
        );
      });

    const elements = fillWithPlaceholders(workingSetImagesElements, {
      placeholder: ImageCardPlaceholder,
      multipleOf: IMAGE_MULTIPLES,
      minimum: NUMBER_OF_IMAGES_NEEDED,
      props: {kitToken},
    });

    return (
      <div className="kit-components">
        <div className="kit-asset-summary m-xs-b-lg">
          <div className="kit-asset-header gg gg-bottom">
            <h3 className="kit-asset-title gg-col">Images</h3>
            <div className="kit-asset-actions gg-col text-xs-right text-muted">
              <Link className="link-dashed-none" to={`/kits/${this.props.kitToken}/images/upload`}>
                <i className="ficon ficon-uploaded m-xs-r-xs"></i>Upload
              </Link>
            </div>
          </div>

          <hr className="m-xs-y-sm" />

          {this.renderUsage()}

          {this.renderHeaderIntro(!workingSetImagesElements.size > 0)}

          <div className="grid-assets grid-assets-xs-4 kit-assets kit-assets-named kit-assets-images-md">
            {[...elements]}
          </div>

        </div>
      </div>
    );
  },

  renderSpinner() {
    return (
      <div className="is-loading is-loading-images m-xs-x-0 bg-body p-xs-a-xl br-a">
        <Spinner size={SIZE_LARGE} />
      </div>
    );
  },

  render() {
    const {
      workingSetImages: workingSetImagesRequest,
      subscription: subscriptionRequest,
    } = this.requests;
    const mainRequests = [workingSetImagesRequest, subscriptionRequest];

    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Requesting any={mainRequests} render={this.renderSpinner} />
        <Done all={mainRequests} render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(ImagesController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/ImagesController.js